import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html'
})
export class OfferComponent implements OnInit, OnDestroy {

  //-- VARIABLES -------------------------------------------------------|

  data: any = {};

  private $appData: Subscription;

  //-- CONSTRUCTOR -----------------------------------------------------|

  constructor(private apiService: ApiService, private appSerivce: AppService) {
    this.$appData = this.apiService.$appData.subscribe(data => { this.applyValues(data) });
  }

  //-- EVENTS ----------------------------------------------------------|


  //-- UTILITY METHODS -------------------------------------------------|

  applyValues(res: any) {
    this.data = res;
  }

  //-- INITIALIZE ------------------------------------------------------|

  ngOnInit() {
    const data = this.apiService.getData();
    this.applyValues(data);
    this.appSerivce.addClickEvent();
  }

  //-- DESTORY ---------------------------------------------------------|

  ngOnDestroy() {
    if (this.$appData) { this.$appData.unsubscribe(); }
  }

  //--------------------------------------------------------------------|

}
